export const LOCALE_REQUESTED = "LOCALE_REQUESTED";
export const LOCALE_RECEIVED = "LOCALE_RECEIVED";
export const LOCALE_REQUEST_FAILED = "LOCALE_REQUEST_FAILED";

export const requestLocale = localeId => ({ type: LOCALE_REQUESTED, localeId: localeId });
export const receiveLocale = (localeId, localeMessages) => ({
  type: LOCALE_RECEIVED,
  payload: {
    localeMessages: localeMessages,
    localeId: localeId
  }
});
